import { connect } from 'react-redux';
import { mirrorCategory } from 'shared/store/actions/knowledge.categories.actions';
import {
  generateBreadcrumbs,
  getCategoriesById,
  getCategoryById,
  getRoot,
  isSection,
} from 'shared/store/selectors/knowledge.selector';
import { MirrorCategoryPopupComponent } from '../../../../../../components/mirror-category/mirror-category-popup.component';
import { STORE_ENTITY_TYPES } from 'shared/constants';

const mapStateToProps = ({ knowledge }, { id }) => {
  const category = getCategoryById(knowledge, { id });

  // Disable self, direct parent, and descendants — backend rejects all three.
  const parentId = category?.path?.split(',').pop();
  const descendantIds = Object.values(knowledge.categoriesById || {})
    .filter(c => c.path?.split(',').includes(id))
    .map(c => c.id);
  const disabledIds = [id, ...(parentId ? [parentId] : []), ...descendantIds];

  return {
    item: category,
    getRoot,
    getCategoriesById,
    getCategoryById,
    generateBreadcrumbs,
    isSection,
    isCategoryMove: true,
    entity: STORE_ENTITY_TYPES.KNOWLEDGE,
    disabledIds,
  };
};

export const KnowledgeCategoryMirrorPopup = connect(mapStateToProps, {
  doMirror: mirrorCategory,
})(MirrorCategoryPopupComponent);
